export default "__VITE_ASSET__5EhYdHbR__"